import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Badge, cx } from "./ui";

const NAV = [
  { to: "/", label: "Dashboard", exact: true },
  { to: "/users", label: "Users" },
  { to: "/projects", label: "Projects" },
  { to: "/organisations", label: "Organisations" },
  { to: "/config", label: "Config" },
  { to: "/signing", label: "Signing" },
  { to: "/feature-flags", label: "Feature flags" },
  { to: "/rate-limits", label: "Rate limits" },
  { to: "/auth-sessions", label: "Auth sessions" },
  { to: "/audit-log", label: "Audit log" },
];

const ROLE_TONE = { super_admin: "purple", admin: "blue", viewer: "slate" } as const;

export default function Layout() {
  const { admin, logout, hasRole } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return (
    <div className="flex min-h-screen">
      <aside className="fixed inset-y-0 flex w-56 flex-col border-r border-slate-200 bg-rail-950 text-white">
        <div className="border-b border-white/10 px-4 py-4">
          <p className="text-sm font-bold tracking-wide">RailAssurance</p>
          <p className="text-xs text-rail-300">Admin Portal</p>
        </div>
        <nav className="flex-1 space-y-0.5 overflow-y-auto px-2 py-3">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                cx(
                  "block rounded-md px-3 py-1.5 text-sm transition-colors",
                  isActive ? "bg-rail-700 font-medium text-white" : "text-rail-200 hover:bg-rail-800 hover:text-white",
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
          {hasRole("super_admin") && (
            <NavLink
              to="/admins"
              className={({ isActive }) =>
                cx(
                  "mt-3 block rounded-md border-t border-white/10 px-3 py-1.5 pt-3 text-sm transition-colors",
                  isActive ? "bg-rail-700 font-medium text-white" : "text-rail-200 hover:bg-rail-800 hover:text-white",
                )
              }
            >
              Admin management
            </NavLink>
          )}
        </nav>
        <div className="border-t border-white/10 px-4 py-3 text-xs">
          <p className="truncate font-medium text-white">{admin?.email}</p>
          <div className="mt-1 flex items-center justify-between">
            {admin && <Badge tone={ROLE_TONE[admin.role]}>{admin.role.replace("_", " ")}</Badge>}
            <button onClick={handleLogout} className="text-rail-300 hover:text-white">
              Sign out
            </button>
          </div>
        </div>
      </aside>
      <main className="ml-56 flex-1 bg-slate-100 px-6 py-6">
        <div className="mx-auto max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
